import React, { useRef } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { TimelineHeader } from "./TimelineHeader";
import { TimelineCanvas } from "./TimelineCanvas";
import { useTimelineExport } from "./hooks/useTimelineExport";
import type { TimelineData } from "@/lib/chat/parseTimelineBlock";

interface TimelineModalProps {
  open: boolean;
  onClose: () => void;
  data: TimelineData;
}

export const TimelineModal: React.FC<TimelineModalProps> = ({
  open,
  onClose,
  data,
}) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const { exportPNG } = useTimelineExport(exportRef, data.title);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[90vh] w-[95vw] max-w-none flex-col gap-0 p-0 sm:rounded-2xl [&>button:last-child]:hidden">
        <div ref={exportRef} className="flex flex-col flex-1 min-h-0">
          <TimelineHeader
            title={data.title}
            mode="expanded"
            onDownload={exportPNG}
            onToggleExpand={onClose}
          />
          <div className="flex-1 min-h-0 overflow-auto bg-muted/20 scrollbar-hide">
            <TimelineCanvas data={data} maxHeight="none" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
